import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { TextListProvider } from './TextList.Context/Provider.es.js';
import { TextListItem } from './TextList.Item/TextList.Item.es.js';

const TextList = ({ children, type = 'bulleted', density = 'default', size = 'base', className })=>{
    const ListElement = type === 'numbered' ? 'ol' : 'ul';
    return jsx(TextListProvider, {
        size: size,
        type: type,
        children: jsx(ListElement, {
            className: classNames('cb-textlist', type, `density-${density}`, className),
            children: children
        })
    });
};
TextList.displayName = 'TextList';
TextList.Item = TextListItem;

export { TextList, TextList as default };
//# sourceMappingURL=TextList.es.js.map
